import React, { useEffect, useState } from "react";
import { Button, CircularProgress, makeStyles } from "@material-ui/core";
import { BsArrowLeftShort } from "react-icons/bs";
import { Form, useFormik, FormikProvider } from "formik";
import axios from "axios";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import Cookies from "js-cookie";
import { Skeleton } from "@material-ui/lab";
import { TfiSave } from "react-icons/tfi";
import { toast } from "react-toastify";
import formModel from "./validationSchemas/formModel";
import ThemeForm from "./components/ThemeForm";
import { validateThemeFormSchema } from "./validationSchemas/ShopifyValidateFormSchema";
import { useHistory } from "react-router-dom"

const { formId, formField } = formModel;

const useStyles = makeStyles((theme) => ({
    saveBtn: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
}));

function ShopifyAppThemeSetting({ userinfo, language, feedsetting }) {
    const classes = useStyles();
    const history = useHistory();

    const currentValidationSchema = validateThemeFormSchema;

    const [initialFormObj, setInitialFormObj] = useState({});

    useEffect(() => {
        if (feedsetting) {
            setInitialFormObj({
                multilanguage: feedsetting.ifm_multilingual,
                theme: feedsetting.ifm_theme,
                wl_primarycolor: feedsetting.ifm_NaturalPrimaryColor,
                n_fontcolor: feedsetting.ifm_NaturalFontColor,
                lab_primary: feedsetting.ifm_LabPrimaryColor,
                lab_fontcolor: feedsetting.ifm_LabFontColor,
            });
        }
    }, [feedsetting]);

    const formik = useFormik({
        initialValues: initialFormObj,
        enableReinitialize: true,
        validationSchema: currentValidationSchema,
        onSubmit: _handleSubmit,
    });

    function _handleSubmit(values, actions) {
        actions.setSubmitting(true);
        let FinalData = {
            user_id: userinfo.id,
            data: [],
        };
        if (values.theme) {
            FinalData.data.push({ ifm_theme: values.theme });
        }
        if (values.wl_primarycolor) {
            FinalData.data.push({
                ifm_NaturalPrimaryColor: values.wl_primarycolor,
            });
        }
        if (values.n_fontcolor) {
            FinalData.data.push({ ifm_NaturalFontColor: values.n_fontcolor });
        }
        if (values.lab_primary) {
            FinalData.data.push({ ifm_LabPrimaryColor: values.lab_primary });
        }
        if (values.lab_fontcolor) {
            FinalData.data.push({ ifm_LabFontColor: values.lab_fontcolor });
        }
        if (values.multilanguage) {
            FinalData.data.push({ ifm_multilingual: values.multilanguage });
        }

        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/update-iframe`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: FinalData,
        })
            .then((res) => {
                if (res.data.success) {
                    toast.dismiss();
                    toast.success(
                        "Your Shopify App Theme Setting Updated Successfully.."
                    );
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            }).finally(() => {
                actions.setSubmitting(false);
            });
    }

    if (!Object.keys(formik.values).length) {
        return (
            <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
            </>
        );
    }

    return (
        <div className="row">
            <div className="col-12 ccmode-setting-sticky-header">
                <div
                    className={`col-12 px-0 setting-title pb-5 border-bottom ${classes.cardHeader}`}
                >
                    <div className="d-flex flex-column">
                        <span>Shopify App THEME SETTING</span>
                        <span className="small text-capitalize">
                            Shopify App theme setting
                        </span>
                    </div>
                    <div>
                        <Button
                            disabled={formik.isSubmitting}
                            variant="contained"
                            color="primary"
                            className={classes.saveBtn}
                            onClick={formik.submitForm}
                        >
                            <TfiSave className="mr-3" size={13} />
                            {language.SETTING_PASSWORD_SAVE}
                            {formik.isSubmitting && (
                                <CircularProgress
                                    size={16}
                                    className={"ml-3"}
                                />
                            )}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-4">
                <FormikProvider value={formik}>
                    <Form id={formId}>
                        <ThemeForm
                            formField={formField}
                            values={formik.values}
                            setFieldValue={formik.setFieldValue}
                            language={language}
                            feedsetting={feedsetting}
                        />
                    </Form>
                </FormikProvider>
            </div>
        </div>
    );
}

export default ShopifyAppThemeSetting;
